// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__31uOQ","header":"ReportDetails_header__2C_-V","title":"ReportDetails_title__1Hte3","left":"ReportDetails_left__2_rhX"};